import React from 'react';
import MaskedInput from 'react-text-mask';
import Cards from 'react-credit-cards';

export default function Receiver(props) {
  return (

    <div className="card shadow">
      <div className="card-body">
        <h4 className="card-title text-dark">Digite os dados do cartão</h4>
        <form className="form">
          <div className="form-group">
            <Cards
              cvc={props.cvc}
              expiry={props.expiry}
              focused={props.focused}
              name={props.name}
              number={props.number}
              callback={props.handleCallback}
            />
          </div>
          <div className="form-group">
            <label htmlFor="cardholder">Nome do Portador*</label>
            <div className="input-group">
              <input
                type="text"
                className={"form-control"}
                id="cardholder"
                name="name"
                value={props.name}
                maxLength="150"
                required
                placeholder="Como está no cartão"
                onChange={props.handleInputChange}
                onFocus={props.handleInputFocus}
              />
              <div className="input-group-prepend">
                <span className="input-group-text"><i className="fa fa-id-card"></i></span>
              </div>
              <div className="invalid-feedback">
                Informe o nome impresso no cartão
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-5">
              <label htmlFor="document">Telefone*</label>
              <div className="input-group">
                <MaskedInput
                  mask={['(',/\d/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/ ,/\d/, /\d/]}
                  className={"form-control"}
                  placeholder="Telefone"
                  guide={false}
                  name="phone_number"
                  id="phone_number"
                  value={props.phone_number}
                  onChange={props.handleInputChange}
                  required
                />
                <div className="input-group-prepend">
                  <span className="input-group-text"><i className="fa fa-phone"></i></span>
                </div>
                <div className="invalid-feedback">
                  Informe um telefone para contato
              </div>
              </div>
            </div>

            <div className="form-group col-7">
              <label htmlFor="document_number">E-mail*</label>
              <div className="input-group">
                <input
                  type="text"
                  className={"form-control"}
                  id="email"
                  name="email"
                  value={props.email}
                  maxLength="150"
                  required
                  placeholder="Email para contato"
                  onChange={props.handleInputChange}
                  onFocus={props.handleInputFocus}
                />

                <div className="input-group-prepend">
                  <span className="input-group-text"><i className="fa fa-at"></i></span>
                </div>
                <div className="invalid-feedback">
                  Informe um email para contato
              </div>
              </div>
            </div>


          </div>


          <div className="form-row">
            <div className="form-group col-4">
              <label htmlFor="document">Tipo de documento*</label>
              <div className="input-group">
                <select
                  onChange={props.handleInputChange}
                  className="form-control"
                  value={props.type_document}
                  id="type_document"
                  name="type_document"
                  required
                >
                  <option value="CPF">CPF</option>
                  <option value="CNPJ">CNPJ</option>
                </select>
                <div className="invalid-feedback">
                  Informe o tipo de documento do portador do cartão
              </div>
              </div>
            </div>
            {
              props.type_document === 'CPF' ?
                (
                  <div className="form-group col-8">
                    <label htmlFor="document_number">CPF do Portador*</label>
                    <div className="input-group">
                      <MaskedInput
                        mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                        className={"form-control"}
                        placeholder="CPF"
                        guide={false}
                        name="document_number"
                        id="document_number"
                        value={props.document_number}
                        onChange={props.handleInputChange}
                        required
                      />

                      <div className="input-group-prepend">
                        <span className="input-group-text"><i className="fa fa-id-badge"></i></span>
                      </div>
                      <div className="invalid-feedback">
                        Informe o documento do portador do cartão
              </div>
                    </div>
                  </div>
                )
                :
                (
                  <div className="form-group col-8">
                    <label htmlFor="document_number">CNPJ do Portador*</label>
                    <div className="input-group">
                      <MaskedInput
                        mask={[/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                        className={"form-control"}
                        placeholder="CNPJ"
                        guide={false}
                        name="document_number"
                        id="document_number"
                        value={props.document_number}
                        onBlur={() => { }}
                        onChange={props.handleInputChange}
                        required
                      />

                      <div className="input-group-prepend">
                        <span className="input-group-text"><i className="fa fa-id-badge"></i></span>
                      </div>
                      <div className="invalid-feedback">
                        Informe o documento do portador do cartão
              </div>
                    </div>
                  </div>
                )
            }

          </div>
          <div className="form-group">
            <label htmlFor="cardnumber">Número do cartão*</label>
            <div className="input-group">
              <input
                type="tel"
                className={"form-control " + (props.numberInvalid && "is-invalid")}
                id="cardnumber"
                name="number"
                value={props.number}
                placeholder="número do cartão de crédito"
                pattern="[\d| ]{16,22}"
                required
                onChange={props.handleInputChange}
                onFocus={props.handleInputFocus}
              />

              <div className="input-group-prepend">
                <span className="input-group-text"><i className="fa fa-credit-card"></i></span>
              </div>
              <div className="invalid-feedback">
                Informe o número do cartão de crédito
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-6">
              <label htmlFor="expiry-mm">Validade*</label>
              <div className="input-group">

                <input
                  type="text"
                  name="expiry"
                  value={props.expiry}
                  id="expiry-mm"
                  className={"form-control"}
                  placeholder="Validade"
                  required
                  onChange={props.handleInputChange}
                  onFocus={props.handleInputFocus}
                />
                <div className="input-group-prepend">
                  <span className="input-group-text"><i className="fa fa-calendar"></i></span>
                </div>

              </div>
              <div className="invalid-feedback">
                A validade do cartão está inconsistente
              </div>
            </div>
            <div className="form-group col-6">
              <label htmlFor="cvv">CVV</label>
              <div className="input-group">

                <input
                  type="tel"
                  name="cvc"
                  className={"form-control"}
                  value={props.cvc}
                  id="cvv"
                  placeholder="*****"
                  required
                  onChange={props.handleInputChange}
                  onFocus={props.handleInputFocus}
                />

                <div className="input-group-prepend">
                  <span className="input-group-text"><i className="fa fa-key"></i></span>
                </div>
              </div>
              <div className="invalid-feedback">
                Informe o código de segurança
              </div>
            </div>
          </div>

          <button type="button" id="btn_pagar" className="btn btn-primary btn-lg btn-block mt-2" disabled={props.checkoutRunning} onClick={props.handleCheckout}>
            {props.checkoutRunning ? "Efetuando pagamento ..." : "Pagar"}
          </button>
        </form>
      </div>
    </div>





  )
}




